import { graphql } from '@api/generated';

export const GET_DEFAULT_CALLER_ID_CONFIGURED = graphql(`
  query GetDefaultCallerIdConfigured {
    defaultCallerIdConfigured
  }
`);
